import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_heade = _resolveComponent("heade");

  var _component_router_view = _resolveComponent("router-view");

  var _component_foote = _resolveComponent("foote");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_heade), _createVNode(_component_router_view), _createVNode(_component_foote)], 64);
}